<span [innerHTML]="content" appLinkHandler></span>
